import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Settings, BookOpenCheck } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import Button from '../../components/ui/Button';
import CertificationsList from '../../components/certifications/CertificationsList';
import { useModuleLicense } from '../../hooks/useModuleLicense';

/**
 * MyCertifications — self-service certifications & licenses register.
 *
 * Any authenticated org member can record and manage their own certifications.
 * HR-licensed users also see a shortcut to the admin register/config.
 */
function MyCertifications() {
  const navigate = useNavigate();
  const { hasAccess: isHr } = useModuleLicense('timesheet', 'hr');

  return (
    <>
      <PageHeader
        title="Certifications & Licenses"
        subtitle="Record your forklift, first aid, truck licence, ACUP and other qualifications"
        icon={<ShieldCheck className="h-6 w-6 text-white" />}
        actionButtons={isHr ? (
          <Button variant="outline" size="sm" onClick={() => navigate('/certifications/admin')}>
            <Settings className="h-4 w-4 mr-1" /> Staff register
          </Button>
        ) : undefined}
      />
      <div className="max-w-4xl mx-auto px-4 py-6">
        {/* A licence is one half of being allowed on a machine; the other is
            the induction a supervisor signs off. */}
        <button
          type="button"
          onClick={() => navigate('/my-inductions')}
          className="mb-4 flex w-full items-start gap-2 rounded-lg border border-lime-200 bg-lime-50 px-3 py-2 text-left text-sm text-lime-900 hover:bg-lime-100"
        >
          <BookOpenCheck className="h-4 w-4 mt-0.5 shrink-0" />
          <span className="min-w-0 break-words">
            Operating a machine also needs an induction from your supervisor, and every new starter reads the company
            policies. See <span className="underline">My inductions</span>.
          </span>
        </button>
        <CertificationsList typeModuleFilter="general" />
      </div>
    </>
  );
}

export default MyCertifications;
